/**
 * Platform detection utilities
 */

export type Platform = 'web' | 'react-native' | 'node';

/**
 * Detect the current runtime platform
 */
export function detectPlatform(): Platform {
  // Check if running in Node.js
  if (
    typeof window === 'undefined' &&
    typeof process !== 'undefined' &&
    process.versions?.node
  ) {
    return 'node';
  }

  // Check if running in React Native
  if (
    typeof navigator !== 'undefined' &&
    navigator.product === 'ReactNative'
  ) {
    return 'react-native';
  }

  // Default to web browser
  return 'web';
}

/**
 * Check if running in a browser environment
 */
export function isBrowser(): boolean {
  return typeof window !== 'undefined' && typeof document !== 'undefined';
}

/**
 * Check if running in Node.js
 */
export function isNode(): boolean {
  return detectPlatform() === 'node';
}

/**
 * Check if running in React Native
 */
export function isReactNative(): boolean {
  return detectPlatform() === 'react-native';
}

/**
 * Check if React context is available
 * Useful for determining if we can use hooks/context
 */
export function hasReactContext(): boolean {
  try {
    // Try to import React (will throw in non-React environments)
    // This is a basic check - the actual context check happens in the adapter
    return typeof window !== 'undefined' || isReactNative();
  } catch {
    return false;
  }
}
